import { ChangeDetectorRef, Component, Injectable, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router, Route } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { AppidService } from '../services/appid/appid.service';
import { NavService } from '../services/nav/nav.service';

@Component({
    selector: 'app-sidenav-base',
    template: ``,
    styles: []
})

@Injectable({
    providedIn: 'root'
})

export class SidenavBaseComponent implements OnInit {
    data: any = null;

    @Input("isRegMode") isRegMode: boolean = false;

    constructor(
        public activatedRoute: ActivatedRoute,
        public router: Router,
        public app: AppComponent,
        public AppId: AppidService,
        public navService: NavService,
    ) { }


    ngOnInit(): void {
        this.data = [];

        // Angular url is array of route segments after the domain name.
        this.activatedRoute.url.subscribe(url => {
            this.data = [];

            if (url.length == 0) {
                this.navService.getUnauthFirstNav(this.AppId.appID$).subscribe((response: any) => {

                    // routes will have already been created in superstructure.
                    const savedRoutes = JSON.parse(localStorage.getItem('routes'));
                    
                    const foundRoute = savedRoutes.find(item => item.data?.nav === response.nav_id);
                    
                    window.location.href = '/' + foundRoute.path;
                })
            }

            //combine url array into string
            let urlString = url[0].path; //basepath

            //filter this.router.config to get all routes that begin with the urlString
            let filteredRoutes = this.router.config.filter(x => x.path.split("/")[0] == urlString && x.path.split("/").length > 1);

            this.data.push(...this.buildNavArray(filteredRoutes, "", 0));

            //set all ancestor items to expanded
            //find the currently selected item in data
            let index = 2;
            let parent: any = this.data.find(x => x.link.split("/")[index] == this.router.url.split("/")[index]);
            while (parent != null) {
                index++;
                parent.collapsed = false;
                parent = parent.children.find(y => y.originalLink.split("/")[index] == this.router.url.split("/")[index]);
            }
        });

        //recursively sort this.data by sortOrder
        this.data.sort(this.asIsOrder);

        this.data.forEach(element => {
            if (element.children != null) {
                element.children.sort(this.asIsOrder);
                element.children.forEach(child => {
                    if (child.children != null) {
                        child.children.sort(this.asIsOrder);
                    }
                })
            }
        });
    }

    buildNavArray(routes: Route[], basepath: string, level: number): any {
        let newItems = [];
        // Filter the routes to get only those that match the current basepath and are at the current level.
        let thisLevelRoutes = routes.filter(x => {
            let validPath = true;
            if (basepath != "") {
                validPath = x.path.indexOf(basepath) == 0; // Ensure the path starts with the basepath.
            }
            return x.path.split("/").length == level + 2 && validPath
        });

        thisLevelRoutes.forEach(item => {
            // Recursively build navigation items for child routes of the current item.
            let itemChildren = this.buildNavArray(routes, item.path + "/", level + 1);
            itemChildren.sort(this.asIsOrder);

            let link = "/" + item.path;
            let originalLink = link;
            // If this item does not have a page but its first child does, update the link to the child's link.
            if (!item.data?.hasPage && itemChildren.length > 0 && itemChildren[0].hasPage) {
                link = itemChildren[0].link;
            }
            // Create a new navigation item object with the necessary properties.
            let newItem = {
                label: item.data?.label,
                link: link,
                children: itemChildren,
                hasPage: item.data?.hasPage,
                collapsed: true,
                originalLink: originalLink,
                sortOrder: item.data?.sortOrder
            };

            newItems.push(newItem);
        });

        return newItems;
    }

    hasChildren(data: any): boolean {
        return (data.children.length > 0);
    }

    // When we click on the + or - sign, that click event bubbles up to the parent elements in the DOM. 
    // Without stopPropagation(), the click on the propagates and executes navigateHandler(), which causes navigation to occur instead of just opening the menu.
    expandOrCollapse(item: any, event: Event) {
        event.stopPropagation();
        item.collapsed = !item.collapsed;
    }

    asIsOrder(a, b) {
        return Number.parseInt(a.sortOrder) > Number.parseInt(b.sortOrder) ? 1 : -1;
    }

    //determine if this top nav is active
    isActive(link): boolean {
        //check if this.router.url minus any http parameters matches the link
        let url = this.router.url.split("?")[0];
        return url == link;
    }

}
